'use client'

import { useEffect } from 'react'
import { trackingService } from '../../../lib/services/tracking.service'

export function ClientTracker({ slug }: { slug: string[] }) {
  useEffect(() => {
    const path = Array.isArray(slug) ? slug.join('/') : slug;
    trackingService.trackPageView(`/exames/${path}`);
  }, [slug]);

  return null;
}
